import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'

export const ImageField = ({ record, source, src, title, theme = {} }) => {
  const sourceValue =
    Object.prototype.toString.call(record) === '[object String]' ? record : get(record, source)
  if (!sourceValue) {
    return <div />
  }

  if (Array.isArray(sourceValue)) {
    return (
      <ul>
        {sourceValue.map((file, index) => {
          const titleValue = get(file, title) || title
          const srcValue = get(file, src) || title

          return (
            <li key={index}>
              <img alt={titleValue} title={titleValue} src={srcValue} />
            </li>
          )
        })}
      </ul>
    )
  }

  const titleValue = get(record, title) || title

  return (
    <div className={theme['center-vertical']}>
      <img title={titleValue} alt={titleValue} src={sourceValue} />
    </div>
  )
}

ImageField.propTypes = {
  record: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  source: PropTypes.string.isRequired,
  title: PropTypes.string,
}

export default ImageField



// WEBPACK FOOTER //
// ./ui/Data/ImageField.js